import { Link } from 'react-router-dom'
import Logo from '../Logo'
import AnchorLink from './AnchorLink'
import { EMAIL_CONTACT, NOM_PRODUIT } from '../constants'

export default function SiteFooter() {
  return (
    <footer className="border-t border-brand-100 mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="text-brand-600 mt-3 leading-relaxed">
            Les données officielles de chaque commune, réunies, sourcées et expliquées.
          </p>
        </div>
        <div>
          <p className="font-semibold text-brand-700 mb-3">Produit</p>
          <ul className="space-y-2 text-brand-600">
            {/* Le footer rend SUR la landing : sans AnchorLink, ces deux liens sont morts
                dès que l'URL porte déjà le hash (bug remonté par Marc le 02/08). */}
            <li><AnchorLink to="/#recherche" className="inline-block py-2 hover:text-accent-600 transition">L'Observatoire</AnchorLink></li>
            <li><AnchorLink to="/#tarifs" className="inline-block py-2 hover:text-accent-600 transition">Tarifs</AnchorLink></li>
            <li><Link to="/epci" className="inline-block py-2 hover:text-accent-600 transition">Offre intercommunale</Link></li>
            <li><Link to="/collectivites" className="inline-block py-2 hover:text-accent-600 transition">Collectivités : comment acheter</Link></li>
            <li><Link to="/faq" className="inline-block py-2 hover:text-accent-600 transition">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-semibold text-brand-700 mb-3">Entreprise</p>
          <ul className="space-y-2 text-brand-600">
            <li><Link to="/about" className="inline-block py-2 hover:text-accent-600 transition">À propos</Link></li>
            <li><Link to="/contact" className="inline-block py-2 hover:text-accent-600 transition">Contact</Link></li>
            <li><a href={`mailto:${EMAIL_CONTACT}`} className="inline-block py-2 hover:text-accent-600 transition">{EMAIL_CONTACT}</a></li>
          </ul>
        </div>
        <div>
          <p className="font-semibold text-brand-700 mb-3">Légal</p>
          <ul className="space-y-2 text-brand-600">
            <li><Link to="/mentions-legales" className="inline-block py-2 hover:text-accent-600 transition">Mentions légales</Link></li>
            <li><Link to="/cgv" className="inline-block py-2 hover:text-accent-600 transition">CGU / CGV</Link></li>
            <li><Link to="/confidentialite" className="inline-block py-2 hover:text-accent-600 transition">Confidentialité</Link></li>
            <li><Link to="/accessibilite" className="inline-block py-2 hover:text-accent-600 transition">Accessibilité</Link></li>
            <li><a href="/licences-tiers.txt" className="inline-block py-2 hover:text-accent-600 transition">Licences des composants tiers</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-100 py-5 text-center text-xs text-brand-600">
        © 2026 {NOM_PRODUIT} — données officielles, sourcées et tenues à jour.
      </div>
    </footer>
  )
}
